import React from 'react'
import styles from './Footer.module.sass'
import logo from '../../assets/logo&title.svg'
import { Icon } from '../ui/Icon'
import twitter_icon from '../../assets/twitter.svg'
import discord_icon from '../../assets/discord.svg'
import medium_icon from '../../assets/medium.svg'
import instagram_icon from '../../assets/instagram.svg'
import expend_icon from '../../assets/Expend_icon.svg'
import { useMediaQuery } from '@chakra-ui/react'

export const Footer = () => {
    const [largerThan768px] = useMediaQuery('(min-width: 768px)')

    return (
        <footer>
            {largerThan768px ? (
                <div className={styles.footer}>
                    <div className={styles.pairfooter1}>
                        <div className={styles.footersize}>
                            <div>
                                <img
                                    className={styles.logo}
                                    src={logo}
                                    alt="logo"
                                />
                            </div>
                            <div className={styles.footerfont}>
                                Sed ut perspiciatis unde omnis iste natus error
                                sit voluptatem accusantium doloremque
                                laudantium, totam rem aperiam, eaque ipsa.
                            </div>
                        </div>
                        <div className={styles.footersize1}>
                            <div className={styles.footersize2}>
                                © 2024 Elosys, All Rights Reserved
                            </div>
                            <div>|</div>
                            <div>Terms & Conditions</div>
                            <div>|</div>
                            <div>DOCs</div>
                        </div>
                    </div>
                    <div className={styles.pairfooter2}>
                        <div className={styles.bigpairicon}>
                            <div className={styles.pairicon}>
                                <img src={twitter_icon} alt="twitter_icon" />
                                <h1 className={styles.pairfont}>Twitter</h1>
                            </div>
                            <div className={styles.pairicon}>
                                <h1
                                    className={`${styles.pairfont} ${styles.footersize2}`}>
                                    @Elosys_Official
                                </h1>
                                <img src={expend_icon} alt="expend_icon" />
                            </div>
                        </div>
                        <div className={styles.bigpairicon}>
                            <div className={styles.pairicon}>
                                <img src={discord_icon} alt="discord_icon" />
                                <h1 className={styles.pairfont}>Discord</h1>
                            </div>
                            <div className={styles.pairicon}>
                                <h1
                                    className={`${styles.pairfont} ${styles.footersize2}`}>
                                    @Elosys_Org
                                </h1>
                                <img src={expend_icon} alt="expend_icon" />
                            </div>
                        </div>
                        <div className={styles.bigpairicon}>
                            <div className={styles.pairicon}>
                                <img src={medium_icon} alt="medium_icon" />
                                <h1 className={styles.pairfont}>Medium</h1>
                            </div>
                            <div className={styles.pairicon}>
                                <h1
                                    className={`${styles.pairfont} ${styles.footersize2}`}>
                                    @Elosys_Blogs
                                </h1>
                                <img src={expend_icon} alt="expend_icon" />
                            </div>
                        </div>

                        <div className={styles.bigpairicon}>
                            <div className={styles.pairicon}>
                                <img
                                    src={instagram_icon}
                                    alt="instagram_icon"
                                />
                                <h1 className={styles.pairfont}>Instagram</h1>
                            </div>
                            <div className={styles.pairicon}>
                                <h1
                                    className={`${styles.pairfont} ${styles.footersize2}`}>
                                    @Elosys
                                </h1>
                                <img src={expend_icon} alt="expend_icon" />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={styles.footer}>
                    <div className={styles.pairfooter1}>
                        <div className={styles.image}>
                            <img
                                className={styles.logo}
                                src={logo}
                                alt="logo"
                            />
                        </div>
                    </div>
                    <div className={styles.pairfooter2}>
                        <div className={styles.pairicon}>
                            <img src={twitter_icon} alt="twitter_icon" />
                        </div>
                        <div className={styles.pairicon}>
                            <img src={discord_icon} alt="discord_icon" />
                        </div>
                        <div className={styles.pairicon}>
                            <img src={medium_icon} alt="medium_icon" />
                        </div>
                        <div className={styles.pairicon}>
                            <img src={instagram_icon} alt="instagram_icon" />
                        </div>
                    </div>
                    <div className={styles.footersize1}>
                        <div className={styles.footersize2}>
                            © 2024 Elosys, All Rights Reserved
                        </div>
                        <div>|</div>
                        <div>Terms & Conditions</div>
                        <div>|</div>
                        <div>DOCs</div>
                    </div>
                </div>
            )}
        </footer>
    )
}
